'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var closeReasons = exports.closeReasons = {
  cancel: 'CLOSE_REASON_CANCEL',
  done: 'CLOSE_REASON_DONE'
};